import { useQuery } from "@apollo/client";
import PropTypes from "prop-types";
import { useEffect, useState } from "react";
import { listSegments } from "../../../graphql/queries/listSegments";

const LABEL_MAP = {
  "user-in-segment": "Included Segments",
  "inclusion-segment": "Included Segments",
  "exclusion-segment": "Excluded Segments",
  "attach-segment": "Attach Segment",
  "detach-segment": "Detach Segment",
};

const SegmentViewComponent = ({ segmentIds = [], customComponentName }) => {
  const { data: segmentsData } = useQuery(listSegments);
  const [selectedSegments, setSelectedSegments] = useState([]);
  const labelText = LABEL_MAP[customComponentName] || "Segments";

  useEffect(() => {
    if (segmentsData) {
      if (typeof segmentIds === "string") {
        const segment =
          segmentsData.listSegments.find((segment) => segment.id === segmentIds) ||
          {};
        setSelectedSegments([segment]);
      } else if (Array.isArray(segmentIds)) {
        const initialSegments = segmentIds.map(
          (item) =>
            segmentsData.listSegments.find((segment) => segment.id === item) || {}
        );
        setSelectedSegments(initialSegments);
      } else {
        setSelectedSegments([]);
      }
    }
  }, [segmentIds, segmentsData]);

  return (
    <>
      {selectedSegments && (
        <div className="additional-fields-container">
          <div className="field-pair">
            <span className="field-label">{labelText}</span>
          </div>
          <div className="field-pair-two-column">
            <span className="field-value">
              {selectedSegments?.map((segment) => segment.name).join(", ")}
            </span>
          </div>
        </div>
      )}
    </>
  );
};

SegmentViewComponent.propTypes = {
  segmentIds: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.arrayOf(PropTypes.string),
  ]),
  customComponentName: PropTypes.string,
};

export default SegmentViewComponent;
